import { Renderer } from '@unseenco/taxi';
import { isDEVMODE, viewStorage } from '../_globals'
import Accordions from '../modules/accordions'

export default class PageFaq extends Renderer {
  initialLoad() {
    const onDOMContentLoaded = () => {
      document.removeEventListener('DOMContentLoaded', onDOMContentLoaded)
      this.onEnter()
    }

    document.addEventListener('DOMContentLoaded', onDOMContentLoaded)
  }

  onEnter() {
    this.DOM = {
      allQuestions: viewStorage.current.querySelector('.AllQuestions')
    }

    this.init()
  }

  init() {
    const {
      allQuestions = null
    } = this.DOM

    if (allQuestions) this.accordionsModule = new Accordions(allQuestions)
  }

  onLeaveCompleted() {
    this.accordionsModule && this.accordionsModule.destroy()
  }
}
